import { useOrganizationStore, useUserStore } from 'store/modules';

export default function (to, from, next) {
    const userStore = useUserStore();
    const organizationStore = useOrganizationStore();

    const isMemberRole = userStore.isMemberRole;
    const isManagerRole = userStore.isManagerRole;
    const isViewOnlyRole = userStore.isViewOnlyRole;
    const isClient = organizationStore.isClient;
    const teamsFlow = organizationStore.featureFlags?.teams_flow;

    const canManageTeams = Boolean(
        teamsFlow && !isClient && !isMemberRole && !isManagerRole && !isViewOnlyRole
    );

    if (to.name === 'settings.organization.teams' && !canManageTeams) {
        next('/');
        return;
    }

    next();
}
